<template>
    <div>
        <el-autocomplete placeholder="请选择学校" :prefix-icon="icon" class="formInput"
                         :fetch-suggestions="searchSchool" @select="checkedSchool" v-model="checkedName"
                         style="width: 100%;">
        </el-autocomplete>
    </div>
</template>

<script>
export default {
    name: 'SubSchool',
    props: ['selectedSchoolName', 'preIcon'],
    created () {
        this.icon = this.preIcon
        this.checkedName = this.selectedSchoolName
    },
    data () {
        return {
            schoolId: 0,
            icon: 'iconfont icon-bank',
            checkedName: ''
        }
    },
    watch: {
        selectedSchoolName (newVal, oldVal) {
            this.checkedName = newVal
        }
    },
    methods: {
        //搜索学校
        searchSchool: function (str, cb) {
            this.$ajax.get('/api/school/search', {
                params: {
                    name: str
                }
            }).then(function (res) {
                let data = res.data
                let items = []
                if (data.count > 0) {
                    data.items.forEach(function (item) {
                        items.push({
                            id: item.id,
                            value: item.name
                        })
                    })
                }
                cb(items)
            }, function () {
                console.log('请求失败')
            })
        },
        checkedSchool: function (item) {
            this.schoolId = item.id
            this.$emit('getSchoolId', item.id)
        }
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/public/sub/SubSchool.vue